import { useDispatch } from 'react-redux'
import { reload } from './actions'

export const useReloadSW = () => {
  const dispatch = useDispatch()
  return () => dispatch(reload())
}
